import { create } from 'zustand';

import type { DayCount, Jurisdiction } from '../../../../backend/src/matter/procedural-timeline/date-resolution';

export type CountingKey =
  | 'uk-ew-calendar'
  | 'uk-ew-business'
  | 'uk-ew-clear-cpr'
  | 'us-federal-calendar'
  | 'us-federal-business';

export interface CountingOption {
  key: CountingKey;
  jurisdiction: Jurisdiction;
  dayCount: DayCount;
  label: string;
}

export const COUNTING_OPTIONS: CountingOption[] = [
  { key: 'uk-ew-calendar', jurisdiction: 'uk-ew', dayCount: 'calendar', label: 'England & Wales: Calendar days' },
  {
    key: 'uk-ew-clear-cpr',
    jurisdiction: 'uk-ew',
    dayCount: 'clear-cpr',
    label: 'England & Wales: Clear days (CPR 2.8)',
  },
  { key: 'uk-ew-business', jurisdiction: 'uk-ew', dayCount: 'business', label: 'England & Wales: Business days' },
  {
    key: 'us-federal-calendar',
    jurisdiction: 'us-federal',
    dayCount: 'calendar',
    label: 'US Federal: Calendar days (FRCP 6(a))',
  },
  { key: 'us-federal-business', jurisdiction: 'us-federal', dayCount: 'business', label: 'US Federal: Business days' },
];

export interface CalculatorPrefill {
  matterId: string;
  eventId: string | null;
  eventName: string | null;
  /** Anchor / source date pre-filled into the calculator input. */
  startDate: Date | null;
  days: number;
  counting: CountingKey;
  timeZone: string | null;
  endDate: Date | null;
}

interface TimelineCalculatorStore {
  prefill: CalculatorPrefill | null;
  position: { x: number; y: number };
  open: (prefill: CalculatorPrefill) => void;
  close: () => void;
  setPosition: (x: number, y: number) => void;
}

export const useTimelineCalculatorStore = create<TimelineCalculatorStore>((set) => ({
  prefill: null,
  position: { x: 0, y: 0 },
  open: (prefill) => {
    set((state) => {
      const hasInitialPos = state.position.x !== 0 || state.position.y !== 0;
      const nextPosition = hasInitialPos ? state.position : { x: window.innerWidth - 480 - 24, y: 120 };
      return { prefill, position: nextPosition };
    });
  },
  close: () => set({ prefill: null }),
  setPosition: (x, y) => set({ position: { x, y } }),
}));
